/**
 * Builds a CSV and triggers a browser download for all graded groups.
 *
 * Columns (one row per student):
 *   Student Name | Student ID | Group Number | Group Name | Graded By |
 *   Basic Features Score | Deployment Score | Bonus Score | Final Score |
 *   General Comment
 */

function parseNum(val) {
  return parseFloat(val) || 0;
}

function calcComplexSection(items) {
  if (!items || !Array.isArray(items)) return 0;
  return items.reduce((acc, item) => {
    const worth = parseNum(item.worth);
    const A = parseNum(item.aesthetics);
    const F = parseNum(item.functionality);
    const aesWeight = item.aestheticsBonus ? 0.3 : 0.2;
    const percentage = 0.8 * F + aesWeight * A;
    return acc + Math.min(worth * (percentage / 100), worth);
  }, 0);
}

function calcSimpleSection(items) {
  if (!items || !Array.isArray(items)) return 0;
  return items.reduce((acc, item) => acc + parseNum(item.score), 0);
}

function escapeCsvField(value) {
  const str = value == null ? '' : String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return '"' + str.replace(/"/g, '""') + '"';
  }
  return str;
}

export function exportGroupsToCSV(groups) {
  const headers = [
    'Student Name',
    'Student ID',
    'Group Number',
    'Group Name',
    'Graded By',
    'Basic Features Score',
    'Deployment Score',
    'Bonus Score',
    'Final Score',
    'General Comment',
  ];

  const rows = [];

  groups.forEach((group) => {
    const basicScore = calcComplexSection(group.basicFeatures);
    const deployScore = calcSimpleSection(group.deployment);
    const bonusScore = calcComplexSection(group.bonus);
    const finalScore = Math.min(basicScore + deployScore + bonusScore, 200);

    const students = group.students && group.students.length > 0
      ? group.students
      : [{ name: '', studentId: '' }];

    students.forEach((student) => {
      rows.push([
        student.name || '',
        student.studentId || '',
        group.groupNumber || '',
        group.groupName || '',
        group.createdBy || '',
        basicScore.toFixed(2),
        deployScore.toFixed(2),
        bonusScore.toFixed(2),
        finalScore.toFixed(2),
        group.generalComment || '',
      ].map(escapeCsvField).join(','));
    });
  });

  const csvContent = [headers.map(escapeCsvField).join(','), ...rows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `grades_export_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
